import { Translator } from 'Translator';
import React from 'react';
import { useLang } from '~/stores/i18n';

const CSS = require('./TranslateButton.module.scss');

function TranslateButton({ translated, onClick }) {
  const lang = useLang();
  if (lang === 'en') {
    return null;
  }
  return (
    <button className={CSS.Button} onClick={onClick}>
      {!translated ? (
        Translator.translate(
          'ExperiencePage.TranslateButton.translate',
          {},
          true,
          'Translate this text to English',
        )
      ) : (
        <span>
          {Translator.translate(
            'ExperiencePage.TranslateButton.showOriginal',
            {},
            true,
            'Show original text',
          )}
          <img
            alt="google logo"
            className={CSS.poweredByGoogle}
            src="https://withlocals-com-res.cloudinary.com/image/upload/w_113,h_14,q_auto,f_auto/v1507462437/translations/powered-by-google-on-white.png"
            width={113}
            height={14}
          />
        </span>
      )}
    </button>
  );
}

export default TranslateButton;
